import template from './bestInterestDutyFlow.template.html';

export default {
  template,
  bindings: {
    validationErrors: '<',
    objectives: '<',
    compliance: '<',
    workflow: '<',
    section: '<',
    isAssetFinanceCommercial: '<'
  },
  controller: class controller {
    constructor(helperService, YesNoOption) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.objectives = ctrl.objectives || {};
        ctrl.compliance = ctrl.compliance || {};
        ctrl.workflow = ctrl.workflow || [];
        ctrl.section = ctrl.section || '';
        ctrl.isAssetFinanceCommercial = ctrl.isAssetFinanceCommercial || false;
        ctrl.showBIDFlows = ctrl.showBIDFlows || false;
        ctrl.bidFlows = !_.isEmpty(ctrl.workflow)
          ? helperService.getBidFlows({ workflow: ctrl.workflow })
          : [];
        ctrl.canShowBIDFlows();
        ctrl.getSetBIDFlows();
      };

      ctrl.canShowBIDFlows = () => {
        switch (ctrl.section) {
          case 'NEEDS_AND_OBJECTIVES':
            ctrl.showBIDFlows =
              ctrl.workflow &&
              (ctrl.workflow.isHomeLoan() ||
                (ctrl.workflow.isAssetFinance() && !ctrl.isAssetFinanceCommercial)) &&
              ctrl.organizationCountry.cca2 !== 'NZ';
            break;
          case 'PRODUCT_REQUIREMENTS':
            ctrl.showBIDFlows =
              ctrl.workflow &&
              ctrl.workflow.isHomeLoan() &&
              ctrl.organizationCountry.cca2 !== 'NZ';
            break;
          case 'AF_COMPLIANCE':
          case 'PRELIMINARY_ASSESSMENT':
            ctrl.showBIDFlows =
              !ctrl.isAssetFinanceCommercial && ctrl.organizationCountry.cca2 !== 'NZ';
            break;
          case 'HL_COMPLIANCE':
          case 'SUMMARY':
            ctrl.showBIDFlows = ctrl.organizationCountry.cca2 !== 'NZ';
            break;
          default:
            ctrl.showBIDFlows = false;
            break;
        }
      };

      ctrl.setCompletedStatus = ({ idx }) => {
        let out = false;
        switch (idx) {
          case 0:
            out = !_.some(
              ctrl.validationErrors,
              (v) => v?.message?.toLowerCase()?.indexOf('needs and objectives') > -1
            );
            break;
          case 1:
            if (ctrl.workflow?.isAssetFinance() && !ctrl.isAssetFinanceCommercial) {
              out = ctrl.compliance?.comments?.analysisAssessmentAndApplicantEducation !== '';
            }
            if (ctrl.workflow?.isHomeLoan()) {
              out = !_.some(
                ctrl.validationErrors,
                (v) => v?.message?.toLowerCase()?.indexOf('product requirements') > -1
              );
            }
            break;
          case 2:
            if (ctrl.workflow?.isAssetFinance() && !ctrl.isAssetFinanceCommercial) {
              out = ctrl.compliance?.comments?.optionsPresentedAndRecommendation !== '';
            }
            if (ctrl.workflow?.isHomeLoan()) {
              out = ctrl.compliance?.comments?.analysisAssessmentAndApplicantEducation !== '';
            }
            break;
          case 3:
            if (ctrl.workflow?.isAssetFinance() && !ctrl.isAssetFinanceCommercial) {
              out =
                ctrl.compliance?.signedDocuments?.creditProposal !== YesNoOption.none.name &&
                ((ctrl.objectives?.signedDocuments?.creditProposal?.name ===
                  YesNoOption.yes.name &&
                  ctrl.objectives?.signedDocuments?.creditProposalDate !== 0) ||
                  (ctrl.objectives?.signedDocuments?.creditProposal?.name ===
                    YesNoOption.no.name &&
                    ctrl.objectives?.signedDocuments?.creditProposalComments !== ''));
            }
            if (ctrl.workflow?.isHomeLoan()) {
              out = ctrl.compliance?.comments?.optionsPresentedAndRecommendation !== '';
            }
            break;
          case 4:
            if (ctrl.workflow?.isHomeLoan()) {
              out =
                ctrl.compliance?.signedDocuments?.creditProposal !== YesNoOption.none.name &&
                ((ctrl.objectives?.signedDocuments?.creditProposal?.name ===
                  YesNoOption.yes.name &&
                  ctrl.objectives?.signedDocuments?.creditProposalDate !== 0) ||
                  (ctrl.objectives?.signedDocuments?.creditProposal?.name ===
                    YesNoOption.no.name &&
                    ctrl.objectives?.signedDocuments?.creditProposalComments !== ''));
            }
            break;
          default:
            break;
        }
        return out;
      };

      ctrl.getSetBIDFlows = () => {
        const len = ctrl.bidFlows?.length || 0;
        for (let i = 0; i < len; i += 1) {
          ctrl.bidFlows[i].isCompleted = ctrl.setCompletedStatus({ idx: i });
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes?.validationErrors?.currentValue) {
          ctrl.getSetBIDFlows();
        }
      };
    }
  }
};
